import { Injectable } from '@angular/core'

import { HttpService } from './http.service'

import { SettingDto } from '../dto'

@Injectable()
export class SettingService {
  constructor(
    private httpService: HttpService) {
  }

  async find() {
    return await this.httpService.get<SettingDto[]>('/admin/setting')
  }

  async update(pageId: string, settingDto: SettingDto) {
    return await this.httpService.put<SettingDto>(`/admin/setting/${pageId}`, settingDto)
  }
}
